module.exports = __webpack_public_path__ + "static/media/icon-success-lg.c3ab2dca.svg";